import { Stack, UI } from '@genial/components';
import { BoxRadius, Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ProductButtonProps } from '../..';
import { AssetSelectedTypeMap } from '../../../../../../store/product/types';
import { ProductsType } from '../../../DynamicAsset/constants';

export interface ResponsiveButtonProps<T extends keyof AssetSelectedTypeMap>
  extends ProductButtonProps<T> {
  text: string;
  tooltip?: string;
  color: ColorTypes.Option;
  icon: IconographyTypes.Option;
  mobileIconColor: ColorTypes.Option;
  mobileButtonIconColor?: ColorTypes.Option;
  onPress: () => void;
}

export const ResponsiveButton: React.FC<ResponsiveButtonProps<ProductsType>> = ({
  text,
  icon,
  color,
  tooltip,
  onPress,
  isDisabled,
  mobileIconColor,
  mobileButtonIconColor,
}) => {
  const buttonWidthRef = React.useRef<number>();

  const button = useBreakpointValue({
    base: (
      <UI.IconButton
        icon={icon}
        testId="return-button"
        iconColor={Color[mobileIconColor]}
        iconSize="xs"
        backgroundColor={Color[mobileButtonIconColor || color]}
        borderRadius={BoxRadius.sm}
        h={Spacing['inline.md']}
        w={Spacing['inline.md']}
        shadow={3}
        onPress={onPress}
        isDisabled={isDisabled}
      />
    ),
    lg: (
      <UI.Button
        testID="button"
        onLayout={(event) => (buttonWidthRef.current = event.nativeEvent.layout.width)}
        maxW={buttonWidthRef.current}
        variant="textLink"
        isDisabled={isDisabled}
        _text={{
          color: Color[color],
          fontFamily: Typography['fontfamily.base.semibold'],
          fontWeight: Typography['fontweight.semibold'],
        }}
        onPress={onPress}
        rightIcon={<UI.Icon name={icon} size="xxs" color={Color[color]} />}>
        {text}
      </UI.Button>
    ),
  });

  if (tooltip) {
    return (
      <UI.Tooltip label={tooltip}>
        <Stack>{button}</Stack>
      </UI.Tooltip>
    );
  }

  return button;
};
